mutation RecalculateRevenueShareReport($id: ID!) {
  recalculateRevenueShareReport(id: $id) {
    id
    status
    purchasesCount
    feePercentages
    salesAmount {
      value
      currency
      valueUSD
    }
    providerFeeAmount {
      value
      currency
      valueUSD
    }
    feeAmount {
      value
      currency
      valueUSD
    }
    refundsAmount {
      value
      currency
      valueUSD
    }
    refundsCount
    disputesAmount {
      value
      currency
      valueUSD
    }
    disputesCount
    reportAmount {
      value
      currency
      valueUSD
    }
    corrections {
      description
      createdAt
      amount {
        value
        currency
        valueUSD
      }
    }
  }
}
